import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-background-50 text-secondary-500 rounded-lg text-sm font-bold">
                糖
              </span>
              <span style={{ fontFamily: "var(--font-heading)" }}>糖果直播</span>
            </Link>
            <p className="text-sm text-background-50/80 leading-relaxed max-w-sm">
              糖果直播致力于为用户提供最新、最全的直播资讯、栏目推荐和使用教程。无论您是直播爱好者还是内容创作者，这里都有您需要的信息。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  用户口碑
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 糖果直播 TangGuo Live. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="/" className="text-xs text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              隐私政策
            </a>
            <a href="/" className="text-xs text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}